import {createWebHistory, createRouter} from "vue-router";

const baseURL = process.env.VUE_APP_BASE_URL;

export const routes = [
    {
        name: 'home',
        path: baseURL,
        meta: {
            title: 'home',
            breadcrumbs: ['home']
        },
        component: () => import('../pages/Home.vue')
    },
    {
        name: 'register',
        path: baseURL + 'register',
        meta: {
            layout: 'main',
            title: 'register',
            breadcrumbs: ['home']
        },
        component: () => import('../pages/Register.vue')

    },
    {
        name: 'dashboard',
        path: baseURL + 'dashboard',
        meta: {
            layout: 'adminpanel',
            title: 'dashboard'
        },
        component: () => import('../pages/Dashboard.vue')
    },
    {
        name: 'contacts',
        path: baseURL + 'contacts',
        meta: {
            layout: 'adminpanel',
            title: 'contacts',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Contactsdb.vue')
    },
    {
        name: 'reservations',
        path: baseURL + 'reservations',
        meta: {
            layout: 'adminpanel',
            title: 'reservations',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Reservations.vue')
    },
    {
        name: 'confirmReservations',
        path: baseURL + 'confirm-reservation',
        meta: {
            layout: 'adminpanel',
            title: 'confirm_reservation',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/ConfirmReservation.vue')
    },
    {
        name: 'tourists',
        path: baseURL + 'tourists',
        meta: {
            layout: 'adminpanel',
            title: 'tourists',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Tourists.vue')
    },
    {
        name: 'payments',
        path: baseURL + 'payments',
        meta: {
            layout: 'adminpanel',
            title: 'payments',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Payments.vue')
    },
    {
        name: 'pricenegotiation',
        path: baseURL + 'pricenegotiation',
        meta: {
            layout: 'adminpanel',
            title: 'price_negotiation',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Pricenegotiation.vue')
    },
    {
        name: 'hotels',
        path: baseURL + 'hotels/',
        meta: {
            layout: 'adminpanel',
            title: 'hotels',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Hotels.vue')
    },
    {
        name: 'contracts',
        path: baseURL + 'contracts',
        meta: {
            layout: 'adminpanel',
            title: 'contracts',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Contracts.vue')
    },
    {
        name: 'supplements',
        path: baseURL + 'supplements',
        meta: {
            layout: 'adminpanel',
            title: 'supplements',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Supplements.vue')
    },
    {
        name: 'prices',
        path: baseURL + 'prices',
        meta: {
            layout: 'adminpanel',
            title: 'prices',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Prices.vue')
    },
    {
        name: 'stopsale',
        path: baseURL + 'stopsale',
        meta: {
            layout: 'adminpanel',
            title: 'stop_sale',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Stopsale.vue')
    },
    {
        name: 'subscription',
        path: baseURL + 'subscription',
        meta: {
            layout: 'adminpanel',
            title: 'subscription',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Subscription.vue')
    },
    {
        name: 'messages',
        path: baseURL + 'messages',
        meta: {
            layout: 'adminpanel',
            title: 'messages',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Messages.vue')
    },

    {
        name: 'devexamples',
        path: baseURL + 'devexamples',
        meta: {
            layout: 'adminpanel',
            title: 'devexamples',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Devexamples.vue')
    },
    {
        name: 'allotment',
        path: baseURL + 'allotment',
        meta: {
            layout: 'adminpanel',
            title: 'allotment',
            breadcrumbs: ['dashboard']
        },
        component: () => import('../pages/Allotment.vue')
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

export default router
